/** Pure helpers for the FileTable component — extension/size formatting
 *  and checkbox-selection state, extracted for vitest coverage. */

/** Uppercased extension badge text ("CSV", "XLSX", "PDF"); "—" when the
 *  filename has none. */
export function fileExtension(filename: string): string {
  const idx = filename.lastIndexOf('.');
  if (idx <= 0 || idx === filename.length - 1) return '—';
  return filename.slice(idx + 1).toUpperCase();
}

/** Human-readable size: 962 B / 4.1 KB / 2.3 MB. */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Toggle one id in a selection set (returns a new Set). */
export function toggleSelected(selected: ReadonlySet<string>, id: string): Set<string> {
  const next = new Set(selected);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}

/** Header checkbox behavior: if every visible row is selected, clear;
 *  otherwise select all visible rows. */
export function toggleAll(selected: ReadonlySet<string>, visibleIds: string[]): Set<string> {
  const allSelected = visibleIds.length > 0 && visibleIds.every((id) => selected.has(id));
  return allSelected ? new Set() : new Set(visibleIds);
}

/** Drop selections that no longer correspond to a visible row (e.g.
 *  after a delete + refetch). */
export function pruneSelected(selected: ReadonlySet<string>, visibleIds: string[]): Set<string> {
  const visible = new Set(visibleIds);
  return new Set([...selected].filter((id) => visible.has(id)));
}
